import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import Modal from './Modal';
import Loader from './Loader';

import BggService from '../services/BggService';

class BggModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      q: null,
      items: [],
      searchMade: false,
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.getGameDetails = this.getGameDetails.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.search = this.search.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen && this.queryRef) {
      this.queryRef.focus();
    }
  }

  handleKeyDown(e) {
    if (e.key === 'Enter' && !isEmpty(this.state.q)) {
      this.queryRef.blur();
      this.search(this.state.q);
    }
  }

  handleSearchClick() {
    if (!isEmpty(this.state.q)) {
      this.search(this.state.q);
    }
  }

  search(q) {
    this.setState({ loading: true, searchMade: true });
    BggService.search(q)
      .then(result => {
        let items = result.items && typeof result.items !== 'string'
          ? result.items
          : [];
        items = Array.isArray(items)
          ? items
          : [items];
        this.setState({ items });
      })
      .finally(() => this.setState({ loading: false }));
  }

  onCloseModal() {
    this.setState({
      loading: false,
      q: null,
      items: [],
      searchMade: false,
    });

    this.props.onClose();
  }

  handleOnChange(e) {
    this.setState({ q: e.target.value });
  }

  getGameDetails(item) {
    BggService.get(item.id, item.type)
      .then(result => {
        this.props.onGameSelected(result.item)
        this.setState({
          items: [],
          q: null,
        });
      });
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} onClose={this.onCloseModal} title="Cerca su BGG">
        <div className="w-full">
          <div className="flex flex-wrap -mx-3 mb-2">
            <div className="w-full md:w-full px-3 mb-6 md:mb-2">
              <div className="relative">
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="title"
                  name="title"
                  type="text"
                  value={this.q}
                  ref={queryRef => this.queryRef = queryRef}
                  onChange={this.handleOnChange}
                  onKeyDown={this.handleKeyDown}
                  placeholder="e.g. 7 Wonders" />
                  <button type="button" disabled={isEmpty(this.state.q)} onClick={this.handleSearchClick} className="absolute inset-y-0 right-0 flex items-center px-4 cursor-pointer text-gray-700">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                      <path d="M23.832 19.641l-6.821-6.821c2.834-5.878-1.45-12.82-8.065-12.82-4.932 0-8.946 4.014-8.946 8.947 0 6.508 6.739 10.798 12.601 8.166l6.879 6.879c1.957.164 4.52-2.326 4.352-4.351zm-14.886-4.721c-3.293 0-5.973-2.68-5.973-5.973s2.68-5.973 5.973-5.973c3.294 0 5.974 2.68 5.974 5.973s-2.68 5.973-5.974 5.973z"/>
                    </svg>
                  </button>
              </div>
            </div>
            <div className="w-full md:w-full px-3 mb-6 md:mb-2">
              {
                this.state.loading
                  ? <Loader colour="#90cdf4" />
                  : <table className="w-full">
                      <tbody>
                        {
                          this.state.items && this.state.items.map(item => (
                            <tr key={item.id} className="hover:bg-blue-100">
                              <td className="py-4 px-2 md:px-6 border-b border-gray-100">{ item.name.value } { item.publishedAt && `(${item.publishedAt.value})` }</td>
                              <td className="py-4 px-2 md:px-6 border-b border-gray-100 text-right">
                              <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={() => this.getGameDetails(item)}>
                                Scegli
                              </button>
                              </td>
                            </tr>
                          ))
                        }
                        {
                          this.state.items && this.state.items.length === 0 && !isEmpty(this.state.q) && this.state.searchMade
                            ? <tr>
                                <td className="py-4 px-6 border-b border-gray-100">Nessun gioco trovato.</td>
                              </tr>
                            : null
                        }
                      </tbody>
                    </table>
              }
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

BggModal.propTypes = {
  onGameSelected: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
};

BggModal.defaultProps = {
  isOpen: false,
};

export default BggModal;